export { default as ModelViewerLifestyleImageOverlay } from './ModelViewerLifestyleImageOverlay';
